import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../config';

const ToolFrame = ({ app }) => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const authToken = localStorage.getItem(config.tokenKey) || '';

  const iframeUrl = useMemo(() => {
    if (!app.url || app.url.startsWith('{{')) return '';
    const target = new URL(app.url.trim());
    const forwarded = new URLSearchParams(location.search);
    forwarded.forEach((value, key) => target.searchParams.set(key, value));
    target.searchParams.set('token', authToken);
    target.searchParams.set('v', String(Date.now()));
    return target.toString();
  }, [app.url, authToken, location.search]);

  useEffect(() => {
    setLoading(true);
  }, [app.key, location.search]);

  if (!iframeUrl) {
    return (
      <div className="tool-placeholder">
        <p>⚠️ URL non configurée pour <strong>{app.label}</strong></p>
        <small>Renseigne l'URL dans <code>config.js</code></small>
      </div>
    );
  }

  return (
    <div className="tool-frame-shell">
      {loading && (
        <div className="tool-loader">
          <span className="tool-loader-ring" />
          <p>Chargement de {app.label}…</p>
        </div>
      )}
      <iframe
        key={`${app.key}-${location.search}`}
        src={iframeUrl}
        className="iframe-content"
        title={app.label}
        onLoad={() => setLoading(false)}
        allowFullScreen
        allow="clipboard-write; clipboard-read; fullscreen; accelerometer; gyroscope; camera; microphone"
      />
    </div>
  );
};

export default ToolFrame;
